export default {
  GESTOR: {
    IS_GESTOR: true,
    IS_ASSESSOR: true,
    IS_PLANEJADOR: false,
    IS_CLIENTE: false,
  },
  gestor: {
    IS_GESTOR: true,
    IS_ASSESSOR: true,
    IS_PLANEJADOR: false,
    IS_CLIENTE: false,
  },
  ASSESSOR: {
    IS_GESTOR: false,
    IS_ASSESSOR: true,
    IS_PLANEJADOR: false,
    IS_CLIENTE: false,
  },
  PLANEJADOR: {
    IS_GESTOR: false,
    IS_ASSESSOR: false,
    IS_PLANEJADOR: true,
    IS_CLIENTE: false,
  },
  profissional: {
    IS_GESTOR: false,
    IS_ASSESSOR: true,
    IS_PLANEJADOR: false,
    IS_CLIENTE: false,
  },
  FINANCEIRO: {
    IS_GESTOR: false,
    IS_ASSESSOR: true,
    IS_PLANEJADOR: false,
    IS_CLIENTE: false,
    IS_FINANCIAL: true,
  },
  financeiro: {
    IS_GESTOR: false,
    IS_ASSESSOR: true,
    IS_PLANEJADOR: false,
    IS_CLIENTE: false,
    IS_FINANCIAL: true,
  },
  CLIENTE: {
    IS_GESTOR: false,
    IS_ASSESSOR: false,
    IS_PLANEJADOR: false,
    IS_CLIENTE: true,
  },
  cliente: {
    IS_GESTOR: false,
    IS_ASSESSOR: false,
    IS_PLANEJADOR: false,
    IS_CLIENTE: true,
  },
}
